import { Chip, ChipProps } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

type StatusInfoProps = {
  isCompleted: boolean;
  text?: string | null | undefined;
  showIcon?: boolean | null | undefined;
  showWithoutColour?: boolean | null | undefined;
};

export function StatusInfo({
  isCompleted,
  text,
  showIcon,
  showWithoutColour,
  ...props
}: StatusInfoProps & ChipProps) {
  const getColor = () => {
    if (showWithoutColour) {
      return undefined;
    }

    return isCompleted ? 'primary' : 'secondary';
  };

  const getIcon = () => {
    if (showIcon) {
      return isCompleted ? <CheckCircleOutlineIcon /> : <InfoOutlinedIcon />;
    }

    return undefined;
  };

  return (
    <Chip color={getColor()} icon={getIcon()} label={text || ''} {...props} />
  );
}
